<template>
  <div class="desktop-theflow">
    <div class="wrapper">
      <div class="header">
        <div class="logo"></div>
        <div class="header-menu">
          <a>фото</a>
          <a>клипы</a>
          <a>Рецензии</a>
          <a>Альбомы</a>
          <a>Тексты</a>
          <a>Новости</a>
        </div>
        <input class="seach" type="text" placeholder="Поиск">
        <div class="age">16+</div>
        <div class="mini-header">
          <div class="mini-menu-burger"></div>
          <div class="mini-menu-seach"></div>
        </div>
       </div>
      <div class=bread-crumbs>
        <u>Главная</u><span> / </span>
        <u>Рецензии</u><span> / </span>
        <span>Если вы не слушали предыдущие микстейпы Dopeclvb, то новый вам послушать надо. И вот почему</span>
      </div>
      <div class="main-block">
        <div class="right-block">
          <div ref="buzz" class="banner">
            <buzzCode @ready="ready" :id="id"></buzzCode>
          </div>
        </div>
        <div class="left-block">
          <div class="article-header">
            <div class="article-date">04 мая 2017</div>
            <div class="article-author">Текст: Леша Горбаш</div>
          </div>
          <h1>Если вы не слушали предыдущие микстейпы Dopeclvb, то новый вам послушать надо. И вот почему</h1>
          <h2>Спойлер: такого жизнерадостного рэпа вы больше нигде не услышите.</h2>
          <div class="social"></div>
          <img src="/pages/desktopTheFlow/img/1.jpg">
          <p>В середине “Dopetape 4” спряталась песня “Вечеринка нулевых”, где друг друга подгоняют отсылки к золотому периоду творчества Тимбалэнда, игре “Need for Speed: Underground” и той самой эпохе канала MTV, где “Клуб”, “Тачка на прокачку” и, конечно, “Будущие мамы”. Только меня не покидает чувство, что значительная часть аудитории Dopeclvb ловит эти отсылки как-то отдалённо: “Ах да, эпоха нулевых, видел мемы какие-то”. А не как я, бежит пересматривать “Promiscuous” с “What Goes Around” и борется с желанием найти на рутрекере ту самую NFS.
            <p>И тем не менее, новый “Dopetape” — музыка, которую нужно включать во всех школах. Потому что архаичных взглядов там хватает и так. Да и в целом, негативных новостей в последнее время куда больше, чем событий радостных. А в 2007, к глупым чёлкам, грустным эмо-песням и с большего примитивному рэпу возвращаться тоже не очень хочется.</p>
            <p>В 2017 у нас есть Dopeclvb, с музыкой которых вырасти неприятным мнительным дураком станет чуть сложнее — и я не знаю, чего ещё можно требовать от молодёжной музыки. Группировка молодых людей, у которых положительная энергетика бьёт через край. Когда слышно — артисты бесхитростно и в кайф для себя записали очередной релиз. И если к прежним “Dopetape” возникали вопросы по содержанию — было много воды — сейчас с этим всё в полном порядке.</p>
            <p>Сияет тут каждый. Glebasta Spal — на “Джунглях”. Basic Boy вроде и повторяет слово “флекс” пять раз подряд на “Диско-подземелье”, а всё равно класс. i61 превращает “Лоулайф” в песню, к которой я часто буду возвращаться летними ночами. “Хорошие парни” — готовый гимн для всех, кому плюс-минус 20.</p>
            <p>И отдельно о Thomas Mraz. Который с каждой песней делает уверенный шаг вперёд и уже больше года не делает осечек. “May 13”, “Do not Shake the Spear”, фиты с Яниксом и другими артистами — когда Томас в последний раз стрелял вхолостую? Так и тут: что “Дорогая”, что “Хорошие парни”, что (в чуть меньшей степени) “Доуп” — это такие мощные выстрелы в девятку из-за штрафной, что Денис Глушаков обзавидуется.</p>
            <p>Новый “Dopetape” стоит слушать не только школьникам, но и вообще всем — весна как раз берёт своё, холодная серость уходит далеко и надолго (ну, наверное), а лучшего саундтрека для хорошего настроения и классных вечеров не было уже очень давно.</p>
            <p>Дорогая, кажется, я снова хочу слушать рэп.</p>
            <div class="pic"><img src="/pages/desktopTheFlow/img/2.jpg"></div>
            <div class="listen">
              <br>
              <strong>СЛУШАТЬ "DOPET4PE"</strong>
              <br>
              <br>
              <br>
              <strong>Лучшие альбомы первой половины 2020-го в подкасте "Редколлегия"</strong>
            </div>
        </div>
      </div>
      <div class="footer">
        <div class="footer-table">
          <table>
            <tr>
              <td>Фото</td>
              <td>Клипы</td>
              <td>О проекте</td>
            </tr>
            <tr>
              <td>Клипы</td>
              <td>Тексты</td>
              <td>Контакты</td>
            </tr>
            <tr>
              <td>Рецензии</td>
              <td>Новости</td>
              <td>Карта сайта</td>
            </tr>
          </table>
        </div>
        <div class="footer-info">
          THE FLOW © 2020
          <br>
          <br> Использование материалов возможно только с письменного
          <br> разрешения редакции, при этом ссылка на источник обязательна.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import buzzCode from '@/components/buzzCode.vue';

export default {
  name: 'siteDesktop2',
  data() {
    return {
      buzzC: '',
    };
  },
  props: {
    id: {
      type: String,
    },
    platform: {
      type: String,
    },
  },
  components: {
    buzzCode,
  },
  computed: {
  },
  methods: {
    ready() {
      this.$emit('ready');
    },
  },
};
</script>

<style scoped>

.desktop-lifehacker{
  background-color: #ececec;
}

@font-face {
  font-family: 'PTSans';
  src: local('PTSans'),url(/pages/desktopTheFlow/fonts/PTSans.ttf) format('truetype');
};

html {
  font-family: "PTSans", sans-serif
}

.wrapper {
  background-color: #fff;
  padding-left: 20px;
  padding-right: 16px;
  padding-bottom: 20px;
  /*max-width: 100%;*/
  box-sizing: border-box;
  max-width: 1260px;
  margin-left: auto;
  margin-right: auto;
  overflow-y: auto;
}
.header {
  position: relative;
  width: 100%;
  display: flex;
  padding-bottom: 45px;
  font-size: 15px;
  background-image: url(/pages/desktopTheFlow/img/header.png);
  background-repeat: no-repeat;
  background-position: center bottom;
}
.header a {
  display: inline-block;
  text-transform: uppercase;
  color: inherit;
  text-decoration: none;
  font-size: 15px;
  line-height: 1;
  margin-right: 25px;
  padding-bottom: 5px;
}

.logo {
  width: 112px;
  height: 64px;
  margin-top: 7px;
  background: url(/pages/desktopTheFlow/img/logo.svg) no-repeat;
}

.header-menu {
  width: 70%;
  margin-left: 41px;
  margin-top: 32px;
}

.seach {
  width: 198px;
  height: 16px;
  line-height: 24px;
  font-size: 14px;
  margin: 32px 0 0 33px;
  background: url(/pages/desktopTheFlow/img/loop.svg) no-repeat;
  background-size: 8%;
  background-position-x: 98%;
  background-position-y: center;
  border: 1px solid black;
  padding: 4px;
}

.social {
  background: url(/pages/desktopTheFlow/img/social.png) no-repeat;
  padding: 44px;
  background-size: contain;
}

.age {
  position: absolute;
  right: 0;
  top: -6%;
  background-color: #bbbdc0;
  color: white;
  font-weight: bold;
  font-size: 20px;
  padding-top: 10px;
  line-height: 1;
  margin-right: -1%;
}
.bread-crumbs {
  font-size: 11px;
  margin: 10px 0 23px 0;
  padding-left: 6px;
  font-family: "PTSans", sans-serif;
}
.bread-crumbs u {
  color: #038798;
  cursor: pointer;
}
.main-block{
  display: flex;
  align-items: flex-start;
}

.left-block {
  border: 2px solid #cecece;
  margin-right: 20px;
  padding: 26px 51px 41px 56px;
  margin-bottom: 30px;
  font-family: "PTSans", sans-serif;
  order: -1
}

.left-block img {
  width: 100%;
  margin-left: 0;
  display: block !important;
}

h1, h2{
  font-weight: normal;
}

.left-block h1 {
  font-size: 28px;
  line-height: normal;
}

.left-block h2 {
  font-size: 21px;
  line-height: normal;
}

.article-header {
  background: url(/pages/desktopTheFlow/img/bord.png) no-repeat;
  background-size: 13%;
  padding-bottom: 17px;
  padding-left: 13%;
}
.article-date {
  display: inline-block;
  font-size: 11px;
  text-transform: uppercase;
  margin-left: 10px;
}
.article-author {
  display: inline-block;
  font-size: 11px;
  float: right;
}

.right-block {
  width: 300px;
  flex-shrink: 0;
}

.banner {
  width: 300px;
  height: 600px;
  margin: 0 auto;
}
.pic {
  text-align: center;
  margin-top: 3.5em;
  width: 60%;
  margin-left: 20%
}

.listen {
  text-align: center;
  color: #038798;
}

.footer {
  background-image: url(/pages/desktopTheFlow/img/header.png);
  background-repeat: no-repeat;
  background-position: center top;
  padding: 30px 0;
  display: flex;
  font-family: "PTSans", sans-serif
}
.footer-info {
  width: 44%;
  padding-top: 32px;
  vertical-align: top;
  order: -1;
}

.footer-table {
  width: 50%;
  padding: 0 15px;
  box-sizing: border-box;
}

table {
 width: 100%;
 margin: 20px 0;
 border-collapse: collapse;
}

table td, table th {
 padding: 10px;
}

.mini-menu-burger {
  background: url(/pages/desktopTheFlow/img/burger.png) center center / contain no-repeat;
  height: 30px;
  width: 35px;
  position: absolute;
  cursor: pointer;
  top: 28%;
  left: 0;
  background-size: 65%;
  display: none;
}

.mini-menu-seach {
  background: url(/pages/desktopTheFlow/img/loop.svg) center center / contain no-repeat;
  height: 30px;
  width: 35px;
  position: absolute;
  cursor: pointer;
  top: 28%;
  right: 0;
  background-size: 53%;
  display: none
}

@media (max-width: 1100px) {
  .age {
    display: none;
  }
  .header {
    flex-wrap: wrap;
    background-position-x: 50%;
    padding-bottom: 0;
    background-image: url(/pages/desktopTheFlow/img/shadow_header.png);
    background-size: contain;
  }
  .header-menu {
    display: none;
  }
  .seach {
    display: none;
  }
  .logo {
    margin: 22px auto 0 auto;
    width: 60px;
  }
  .left-block {
    width: auto;
    border: none;
    padding: 0 10px 0 10px;
    margin-right: 0;
  }
  .bread-crumbs {
    display: none;
  }
  .left-block h1 {
    font-size: 17px;
    font-weight: bold;
    line-height: 1.4;
  }

  .left-block h2 {
    font-size: 17px;
    font-family: "PT Sans", Arial, sans-serif;
    line-height: 1;
  }

  .main-block {
    display: block;
    padding-top: 26px;
  }
  .right-block {
    width: 100%;
    margin: auto;
  }
  .footer {
    display: block;
    background-position-x: 50%;
    background: url(/pages/desktopTheFlow/img/shadow_header.png) no-repeat;
    background-size: contain;
  }
  .footer-info {
    width: 99%;
    text-align: center;
    line-height: 1.4;
    color: #89898a;
  }
  .footer-table {
    width: 100%;
    text-align: center;
  }

  .mini-menu-burger {
    display: block
  }
  .mini-menu-seach {
    display: block
  }
  .article-header {
    background: url(/pages/desktopTheFlow/img/bord-mini.png) no-repeat;
    background-size: 97%;
    margin-top: 10%;
    padding-bottom: 10%
  }
  .article-date {
    display: none;
  }
  .article-author {
    display: none;
  }
  .social {
    background-image: url(/pages/desktopTheFlow/img/social-mini.png);
    background-repeat: no-repeat;
    background-size: contain;
  }
  .pic  {
    width: 100%;
    margin-left: 0;
  }
}

</style>
